import { useEffect } from 'react' //
import { Box, TextField, Typography } from '@mui/material'
import { StyledPaper, classes } from './ResearchPanelStyles'

interface ResearchPanelProps {
  disabled: boolean;
  value: string;
  onChange: (newValue: string) => void;
  contactUuid: string | null;
  caseUuid: string | null;
  onLinkCase: (caseUuid: string) => void;
}

const ResearchPanel = ({ disabled, value, onChange }: ResearchPanelProps) => {
  const isResearchEnabled = !disabled

  useEffect(() => {
    if (disabled && value !== '') {
      onChange('')
    }
  }, [disabled, value, onChange])

  return (
    <StyledPaper>
      <Box className={classes.header}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          Onderzoek
        </Typography>
      </Box>

      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1.7 }}>
        Antwoord formuleren
      </Typography>
      <TextField
        fullWidth
        multiline
        rows={20}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={!isResearchEnabled}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '4px',
            bgcolor: !isResearchEnabled ? '#f5f5f5' : 'white'
          },
          'mb': 3
        }}
      />
    </StyledPaper>
  )
}

export default ResearchPanel
